export const SIGN_SUCCESS = 'SIGN_SUCCESS';
export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_FAIL = 'SIGN_FAIL';
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_LOADING_FINISHED = 'AUTH_LOADING_FINISHED';
